<date-range (onChange)="onDateRangeChange($event)" [startFormatFun]="startFormatFun" [autoClosePopup]="true"
  (onToolClick)="customToolEventHandler()" [(ngModel)]="rangeDates" (onBeforeClose)="beforeClose()"
  [disabled]="disabled" [headerToolTemplate]="toolButton" [footerToolTemplate]="footerToolButton"
  [autoApplyDateRange]="false" [autofocus]="autofocus">
</date-range>
<ng-template #footerToolButton let-handler="click" let-reset="reset" let-restore="restore" let-setvalue="setRange"
  let-apply="apply" let-close="close">
  <div class="flex-tj">
    <span>
      <span class="vm">
        <button class="btn btn-link" (click)="close($event); tempDateRangeType = dateRangeType" [disabled]="
            tempDateRangeType === dateRangeTypeEnum.custom && (!tempRangeDates.startDate || !tempRangeDates.endDate)">
          <i class="btn-icon btn-left-icon fa fa-undo"></i>
          <span class="btn-text">Cancel</span>
        </button>
      </span>
      <span class="vm">
        <span class="divider-container divider-vertical">
          <span class="divider-line"></span>
        </span>
      </span>
    </span>
    <span>
      <span class="vm">
        <span class="divider-container divider-vertical">
          <span class="divider-line"></span>
        </span>
      </span>
      <span class="vm">
        <button class="btn btn-link" (click)="apply($event)" [disabled]="
            tempDateRangeType === dateRangeTypeEnum.custom &&
            (!tempRangeDates.startDate || !tempRangeDates.endDate)
          ">
          <i class="btn-icon btn-left-icon fa fa-check"></i>
          <span class="btn-text">OK</span>
        </button>
      </span>
    </span>
  </div>
</ng-template>

<ng-template #toolButton let-handler="click" let-close="close" let-setvalue="setRange" let-reset="reset"
  let-component="component">
  <date-range-toolbar [valueSetter]="setvalue" [type]="dateRangeType" [dateRange]="component"
    (onSelectChange)="onToolbarChange($event)"></date-range-toolbar>
</ng-template>
